import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { FraudRiskScore } from '@nk/data-entities-lib';

export const FRAUD_RISK_SCORE_TRANSLATIONS: Record<FraudRiskScore, string> = {
  very_low: extractTranslation('fraud_risk_score.level.very_low'),
  low: extractTranslation('fraud_risk_score.level.low'),
  medium: extractTranslation('fraud_risk_score.level.medium'),
  high: extractTranslation('fraud_risk_score.level.high'),
  very_high: extractTranslation('fraud_risk_score.level.very_high'),
};

export const FRAUD_RISK_SCORE_COLOR: Record<FraudRiskScore, string> = {
  very_low: 'green',
  low: 'green',
  medium: 'yellow',
  high: 'orange',
  very_high: 'red',
} as const;

// Score ranges as defined in company_fraud_risk_score_query.py
export const FRAUD_RISK_SCORE_RANGES: { level: FraudRiskScore; range: string }[] = [
  { level: 'very_high', range: '21+' },
  { level: 'high', range: '16-20' },
  { level: 'medium', range: '6-15' },
  { level: 'low', range: '1-5' },
  { level: 'very_low', range: '0' },
];
